import { BASE_URL } from '../../../Constant';

export const API_GET_DOCUMENT_STATS: string = `${BASE_URL}/document/stats`;
export const API_GET_DOCUMENT_MONTHLY_STATS: string = `${BASE_URL}/document/monthly-stats`;
export const API_GET_PAYMENT_STATS: string = `${BASE_URL}/payment/stats`;
export const API_GET_PAYMENT_MONTHLY_STATS: string = `${BASE_URL}/payment/monthly-stats`;
